<template>
  <div
    v-if="hasSubscription && subscriptionDetails"
    class="mb-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
  >
    <h4 class="text-sm font-medium text-gray-900 dark:text-white mb-3">
      {{ t('app.sysadmin.modal.current_subscription') }}
    </h4>
    <div class="grid grid-cols-2 gap-4 text-sm">
      <div>
        <span class="text-gray-500 dark:text-gray-400">{{ t('app.sysadmin.modal.plan') }}:</span>
        <span class="ml-2 font-medium text-gray-900 dark:text-white">{{ restaurant.plan_name }}</span>
      </div>
      <div>
        <span class="text-gray-500 dark:text-gray-400">{{ t('app.sysadmin.modal.status') }}:</span>
        <span
          :class="getStatusClass(restaurant.subscription_status || '')"
          class="ml-2 px-2 py-1 text-xs font-semibold rounded-full"
        >
          {{ t(`app.sysadmin.status.${restaurant.subscription_status || 'unknown'}`) }}
        </span>
      </div>
      <div>
        <span class="text-gray-500 dark:text-gray-400">{{ t('app.sysadmin.modal.price') }}:</span>
        <span
          v-if="restaurant.current_price != null"
          class="ml-2 font-medium text-gray-900 dark:text-white"
        >
          ${{ Number(restaurant.current_price).toFixed(2) }}/{{ restaurant.billing_cycle === 'annual' ? 'year' : t('app.common.month') }}
        </span>
        <span
          v-else-if="restaurant.monthly_price != null"
          class="ml-2 font-medium text-gray-900 dark:text-white"
        >
          ${{ Number(restaurant.monthly_price).toFixed(2) }}/{{ t('app.common.month') }}
        </span>
        <span
          v-if="restaurant.monthly_price != null || restaurant.annual_price != null"
          class="ml-2 text-xs text-gray-500 dark:text-gray-400"
        >
          (plan: ${{ Number(restaurant.monthly_price ?? 0).toFixed(2) }}/{{ t('app.common.month') }}<span v-if="restaurant.annual_price != null"> · ${{ Number(restaurant.annual_price).toFixed(2) }}/year</span>)
        </span>
      </div>
      <div>
        <span class="text-gray-500 dark:text-gray-400">{{ t('app.sysadmin.modal.renewal') }}:</span>
        <span class="ml-2 font-medium text-gray-900 dark:text-white">{{ restaurant.days_until_renewal }} {{ t('app.common.days') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Restaurant {
  plan_name?: string;
  subscription_status?: string;
  current_price?: number;
  monthly_price?: number;
  annual_price?: number;
  billing_cycle?: string;
  days_until_renewal?: number;
}

const { t } = useI18n();

defineProps<{
  hasSubscription: boolean;
  subscriptionDetails: any;
  restaurant: Restaurant;
  getStatusClass: (status: string) => string;
}>();
</script>
